module.exports = __webpack_public_path__ + "img/cut_icon.88be795f.svg";